<!--
 * @Author: your name
 * @Date: 2021-12-03 08:42:59
 * @LastEditTime: 2022-01-26 18:10:28
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \new-website-1123\src\views\special\fx101\page6.vue
-->
<template>
  <div class="fx101-page5 pt80">
    <div class="img-div">
      <img
        class="d-img"
        src="https://stkjiot.com/resources/special/fx301/9.png"
        alt="上太科技"
      />
      <img
        class="gif-img"
        src="https://stkjiot.com/resources/special/fx101/10-1.gif"
        alt=""
      />
    </div>

    <div class="text-div">
      <ctitle titleb="智能感应·自动倒虫"></ctitle>
      <p class="desc-p">高精度智能传感器，实时探知虫仓情况，云脑全时段控制</p>
    </div>
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1.vue";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.fx101-page5 {
  height: 100vh;
  margin-top: 180px;
  position: relative;
}
.img-div {
  position: absolute;
  top: 0;
  left: calc(50% + 100px);
  height: 80%;
  .d-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  .gif-img {
    position: absolute;
    top: 35.2%;
    left: 50%;
    transform: translateX(-47.5%);
    width: 57.1%;
  }
}
.text-div {
  padding-left: 11vw;
}
.desc-p {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba($color: #fff, $alpha: 0.6);
  line-height: 40px;
  margin-top: 50px;
}
@media screen and (max-width: $mobile-width) {
  .fx101-page5 {
    height: auto;
    padding-bottom: 50px;
    margin-top: 1.64rem;
  }
  .img-div {
    position: relative;
    top: 0;
    left: 0;
    width: 40%;
    margin: auto;
    height: unset;
  }
  .text-div {
    padding-left: 0;
    text-align: center;
  }
  .desc-p {
    font-size: 0.27rem;
    line-height: 0.44rem;
    margin: auto;
    margin-top: 0.27rem;
    width: 86%;
  }
}
</style>
